import React, { useCallback, useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { getMySession } from "../customerApi";
import { useMyText } from "./text";
import { useLanguage } from "../../i18n/LanguageContext";
import { catLabel } from "./format";
import { PageTop, LoadState, StatusTag, StateNote } from "./parts";
import { ResultTag, sessionMeta } from "./ChatLogList";

// 대화 보기 #log/{id} — 연결 문의 카드 + 말풍선(봇 답은 마크다운)
export default function ChatLogDetail({ id, go, customer, onResume }) {
    const tt = useMyText();
    const { lang } = useLanguage();
    const [s, setS] = useState(null);
    const [state, setState] = useState("loading");
    const load = useCallback(() => {
        setState("loading");
        getMySession(id).then((d) => { setS(d); setState("ok"); })
            .catch((e) => setState(e?.response?.status === 404 ? "notfound" : "error"));
    }, [id]);
    useEffect(() => { load(); }, [load]);

    const top = <PageTop title={tt("log.detail")} customer={customer} onBack={() => go("log")} />;
    if (state !== "ok") return <div className="my-wrap">{top}<LoadState state={state} onRetry={load} onList={() => go("log")} /></div>;

    const q = s.inquiry;
    const qName = q ? [tt("log.linked", { id: q.id }), catLabel(q.subcategory, lang) || catLabel(q.category, lang)].filter(Boolean).join(" · ") : "";
    const openQ = () => go(`inq/${q.id}`);
    return (
        <div className="my-wrap">
            {top}
            <div className="my-sec">
                <div className="my-card-h"><ResultTag s={s} /><span className="at">{sessionMeta(s, tt, lang)}</span></div>
                {q && (
                    <div className="my-linked" role="button" tabIndex={0} onClick={openQ} onKeyDown={(e) => { if (e.key === "Enter") openQ(); }}>
                        <StatusTag status={q.status} />
                        <div className="tx"><b>{qName}</b><StateNote item={q} withResult={false} /></div>
                        <span aria-hidden="true">›</span>
                    </div>
                )}
            </div>
            <div className="my-sec my-chat">
                {(s.messages || []).map((m, i) => (
                    <div key={i} className={`my-bub ${m.role === "user" ? "user" : "bot"}`}>
                        {m.role === "user" ? m.content : <ReactMarkdown remarkPlugins={[remarkGfm]}>{m.content}</ReactMarkdown>}
                    </div>
                ))}
            </div>
            <div className="my-act">
                {onResume && <button type="button" className="my-btn pri" onClick={() => onResume(id)}>{tt("resume")}</button>}
                <button type="button" className="my-btn" onClick={() => go("log")}>{tt("list")}</button>
            </div>
        </div>
    );
}
